import { render, staticRenderFns } from "./AdminInvoiceShowTabularActions.vue?vue&type=template&id=f3683cf2&"
import script from "./AdminInvoiceShowTabularActions.vue?vue&type=script&lang=ts&"
export * from "./AdminInvoiceShowTabularActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports